import React, { useCallback } from "react";

import type { RelationGroupChipProps } from "./relationGroupChips.types";

import styles from "./RelationGroupChip.module.css";

/**
 * One context chip. A component rather than an inline handler in the row's map, so each chip binds
 * its own group without allocating a closure per render.
 */
const RelationGroupChip = ({ group, isSelected, label, onSelect }: RelationGroupChipProps) => {
	const onClick = useCallback((): void => onSelect(group), [group, onSelect]);

	return (
		<button
			aria-pressed={isSelected}
			className={isSelected ? styles.chipSelected : styles.chip}
			onClick={onClick}
			type="button">
			{label}
		</button>
	);
};

export default RelationGroupChip;
